import { CreateStructuralRouteFn, StructuralRoute } from '@core/models/route.models';

const createStructuralRoute: CreateStructuralRouteFn = (
  prefix: string | null = '',
  suffix: string = '',
  child?: StructuralRoute,
  paramName: string = 'id'
): StructuralRoute => {
  return {
    prefix,
    suffix,

    get route() {
      const prefix: string = `${this.prefix ? `${this.prefix}/` : ''}`;

      const suffix: string = `${this.suffix ? `/${this.suffix}` : ''}`;

      const _route: string = `${prefix}:${paramName}${suffix}`;

      return child ? `${_route}/${child.route}` : _route;
    },

    construct(param: string, prefixUrl: string = '') {
      const _route: string = `${this.prefix ? `${this.prefix}/` : ''}${param}${this.suffix ? `/${this.suffix}` : ''}`;

      const currentUrl: string = `${prefixUrl ? `${prefixUrl}/` : ''}${_route}`;

      return child ? (_param: string) => child.construct(_param, currentUrl) : currentUrl;
    },
  };
};

export const PROFILE = {
  root: 'profile',
  children: {
    view: 'view',
    edit: 'edit',
    forgotPassword: 'forgot-password',
    resetPassword: 'reset-password',
    intro: 'intro',
  },
};

export const ON_DEMAND_RC = {
  root: 'on-demand',
  children: {
    list: '',
    collection: 'collection',
    class: createStructuralRoute('class'),
  },
};

export const MY_ACTIVITY_RC = {
  root: 'my-activity',
  children: {
    calendar: 'calendar',
    details: 'details',
  },
};

export const AUTH_RC = {
  root: 'auth',
  children: {
    logIn: 'log-in',
    signUp: 'sign-up',
    signUpInstructor: 'sign-up-instructor',
    signUpInstructorUpdate: 'sign-up-instructor-update',
    forgotPassword: 'forgot-password',
    resetPassword: 'reset-password',
    intro: 'intro',
  },
};

export const AUTHORIZED_RC = {
  root: '',
  children: {
    myActivity: createStructuralRoute(),
    onDemand: ON_DEMAND_RC,
  },
};
